module.exports = __webpack_public_path__ + "static/img/205.314dc26.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/205.png
// module id = 504
// module chunks = 3